export default __webpack_public_path__ + "static/MEDIO_POLLO_SOLO_PAPA-d43bf1d4827393d1a129bfc5acd194fb.jpg";